export default __webpack_public_path__ + "static/media/poste.717f2fbe.jpg";